import { render } from "./archival-history.vue?vue&type=template&id=8018e88a"
import script from "./archival-history.vue?vue&type=script&lang=js"
export * from "./archival-history.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__